<template>
  <v-alert
    v-if="entry"
    type="info"
    density="comfortable"
    class="mb-4"
    :data-integration="integrationKey"
  >
    <div class="font-weight-medium">
      {{ $t("ncrm.integrations.privacyNotice.title", { provider: providerName }) }}
    </div>
    <div class="text-body-2 mt-1">
      {{ $t("ncrm.integrations.privacyNotice.location", { location: locationName }) }}
    </div>
    <div class="text-body-2 mt-1">
      {{ $t("ncrm.integrations.privacyNotice.responsibility") }}
    </div>
    <div v-if="entry.modelTrainingWarning" class="text-body-2 mt-1">
      {{ $t("ncrm.integrations.privacyNotice.modelTraining") }}
    </div>
  </v-alert>
</template>

<script>
import { resolveIntegrationPrivacy } from "@/components/ncrm/integrations/integrationPrivacyCatalog.mjs";

// DPIA A4 — blocul care spune, în momentul activării, cine este furnizorul, unde
// prelucrează și că responsabilitatea transferului și a informării persoanelor
// rămâne a operatorului. Pur prezentațional: catalogul este sursa de adevăr.
export default {
  name: "NcrmIntegrationPrivacyNotice",
  props: {
    integrationKey: {
      type: String,
      required: true,
    },
  },
  computed: {
    entry() {
      return resolveIntegrationPrivacy(this.integrationKey);
    },
    providerName() {
      if (!this.entry) return "";
      return this.$t(`ncrm.integrations.privacyNotice.providers.${this.entry.providerKey}`);
    },
    locationName() {
      if (!this.entry) return "";
      return this.$t(`ncrm.integrations.privacyNotice.locations.${this.entry.locationKey}`);
    },
  },
};
</script>
